import { NewsTipCreatedSimpleView } from 'domains/NewsTip/components'
import { PageWrapper } from '@qonsoll/react-design'

const NewsTipSuccessfullyCreated = () => {
  return (
    <PageWrapper height="70vh">
      <NewsTipCreatedSimpleView timeToClose={4000} isGuestMode />
    </PageWrapper>
  )
}

export default NewsTipSuccessfullyCreated
